import { Link } from 'react-router-dom';
import Marquee from 'react-fast-marquee';
import { ShoppingBag, ShoppingCart, Download } from 'lucide-react';
import { toast } from 'sonner';
import { ShareQRButton } from '../ShareQR';
import { SiteSearch } from '../SiteSearch';

export function HomeNav({
  siteSettings,
  totalItems,
  setCartOpen,
  canInstall,
  isInstalled,
  showInstallBanner,
  setShowInstallBanner,
  promptInstall,
}) {
  return (
    <>
      {/* Marquee Header */}
      <div className="border-b border-[#262626] py-3 overflow-hidden" style={{ borderImage: `linear-gradient(90deg, #262626, var(--marquee-color, #DAA520), #262626) 1` }}>
        <Marquee speed={50} gradient={false}>
          <span className="font-cabinet text-6xl sm:text-8xl font-black uppercase tracking-tighter text-transparent mx-8"
            style={{ WebkitTextStroke: `1px var(--marquee-color, #DAA520)` }}>
            {(() => {
              const text = siteSettings?.marquee_text || 'MELODROP • MUSIC • BEATS • DOWNLOADS';
              return `${text} • ${text} •`;
            })()}
          </span>
        </Marquee>
      </div>

      {/* Nav Bar */}
      <div className="border-b border-[#262626] backdrop-blur-sm sticky top-0 z-50" style={{ background: `var(--header-bg, #0A0A0A)` }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-end h-12 gap-3 sm:gap-4">
          <div className="flex-1 max-w-xs sm:max-w-sm">
            <SiteSearch />
          </div>
          <Link to="/store" className="hover:text-white text-xs font-bold uppercase tracking-widest transition-colors flex items-center gap-1.5" style={{ color: `var(--nav-color, #DAA520)` }} data-testid="store-nav-link">
            <ShoppingBag className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Store</span>
          </Link>
          <button onClick={() => setCartOpen(true)} className="relative text-[#A3A3A3] hover:text-white transition-colors" data-testid="nav-cart-icon">
            <ShoppingCart className="w-4 h-4" />
            {totalItems > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-[var(--primary,#FF3B30)] text-white text-[9px] font-bold w-4 h-4 flex items-center justify-center rounded-full">{totalItems}</span>
            )}
          </button>
          <ShareQRButton variant="nav" appButtonSettings={siteSettings?.app_button} />
          <Link to="/admin" className="text-[#666] hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-testid="admin-login-btn">
            Admin
          </Link>
        </div>
      </div>

      {/* PWA Install Banner */}
      {canInstall && !isInstalled && showInstallBanner && (
        <div className="bg-[var(--primary,#FF3B30)]/10 border-b border-[var(--primary,#FF3B30)]/20 py-3 px-4" data-testid="pwa-install-banner">
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-4">
            <p className="text-sm text-white/80">
              <Download className="w-4 h-4 inline mr-1.5 text-[var(--primary,#FF3B30)]" />
              Install the <strong>DugOwtBoi</strong> app for quick access
            </p>
            <button
              onClick={async () => {
                const outcome = await promptInstall();
                if (outcome === 'accepted') toast.success('App installed!');
                setShowInstallBanner(false);
              }}
              className="px-4 py-1.5 bg-[var(--primary,#FF3B30)] text-white text-xs font-bold uppercase tracking-wider hover:bg-white hover:text-[#0A0A0A] transition-colors"
              data-testid="pwa-install-btn"
            >
              Install
            </button>
            <button onClick={() => setShowInstallBanner(false)} className="text-white/40 hover:text-white text-sm">
              Dismiss
            </button>
          </div>
        </div>
      )}
    </>
  );
}
